import axios from 'axios';
import config from '../config';
import { getBearerToken } from '../util/cookie';

// ================ Action types ================ //

export const COUPONS_REQUEST = 'app/CoachSaaS/COUPONS_REQUEST';
export const COUPONS_SUCCESS = 'app/CoachSaaS/COUPONS_SUCCESS';
export const COUPONS_ERROR = 'app/CoachSaaS/COUPONS_ERROR';

export const COUPON_SAVE_REQUEST = 'app/CoachSaaS/COUPON_SAVE_REQUEST';
export const COUPON_SAVE_SUCCESS = 'app/CoachSaaS/COUPON_SAVE_SUCCESS';
export const COUPON_SAVE_ERROR = 'app/CoachSaaS/COUPON_SAVE_ERROR';

// ================ Reducer ================ //

const initialState = {
  coupons: [],
  couponsFetching: false,
  couponsError: null,

  couponSave: null,
  couponSaving: false,
  couponSavingError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case COUPONS_REQUEST:
      return { ...state, couponsFetching: true };
    case COUPONS_SUCCESS:
      return { ...state, couponsFetching: false, coupons: payload };
    case COUPONS_ERROR:
      return { ...state, couponsFetching: false, couponsError: payload };

    case COUPON_SAVE_REQUEST:
      return { ...state, couponSaving: true, couponSavingError: null };
    case COUPON_SAVE_SUCCESS:
      return { ...state, couponSaving: false, couponSave: payload };
    case COUPON_SAVE_ERROR:
      return { ...state, couponSaving: false, couponSavingError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const couponsRequest = () => ({ type: COUPONS_REQUEST });
export const couponsSuccess = data => ({ type: COUPONS_SUCCESS, payload: data });
export const couponsError = error => ({ type: COUPONS_ERROR, payload: error });

export const couponSaveRequest = () => ({ type: COUPON_SAVE_REQUEST });
export const couponSaveSuccess = data => ({ type: COUPON_SAVE_SUCCESS, payload: data });
export const couponSaveError = error => ({ type: COUPON_SAVE_ERROR, payload: error });

// ================ Thunks ================ //

// Calls coachSaaSService's `coupons` resource, matching the
// programs/sessions/clients pattern in this folder.
export const getAllCoupons = () => async (dispatch, getState, sdk) => {
  dispatch(couponsRequest());

  return axios
    .get(`${config.coachSaaSService}coupons`, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    })
    .then(res => {
      dispatch(couponsSuccess(res.data));
      return res.data;
    })
    .catch(err => {
      dispatch(couponsError(err));
      throw err;
    });
};

export const saveCoupon = data => async (dispatch, getState, sdk) => {
  dispatch(couponSaveRequest());

  const params = {
    code: data.code,
    discountType: data.discountType,
    discountValue: data.discountValue,
    appliesToAll: data.appliesToAll,
    listingIds: data.listingIds,
    expiryDate: data.expiryDate,
    maxRedemptions: data.maxRedemptions,
  };

  return axios
    .post(`${config.coachSaaSService}coupons`, params, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    })
    .then(res => {
      dispatch(couponSaveSuccess(res.data));
      return res.data;
    })
    .catch(err => {
      dispatch(couponSaveError(err));
      throw err;
    });
};
